import type { UUID } from '@/utils/uuid';

export const providerQueryKeys = {
  list: (tenantId?: UUID, limit?: number, filter?: string) =>
    ['providers', tenantId, limit ?? null, filter ?? null] as const,
  listByTenant: (tenantId?: UUID) => ['providers', tenantId] as const,
  detail: (tenantId?: UUID, providerId?: UUID) =>
    ['provider', tenantId, providerId] as const,
  featureList: (
    tenantId?: UUID,
    providerId?: UUID,
    limit?: number,
    filter?: string
  ) =>
    ['features', tenantId, providerId, limit ?? null, filter ?? null] as const,
  featureListByProvider: (tenantId?: UUID, providerId?: UUID) =>
    ['features', tenantId, providerId] as const,
  featureListByTenant: (tenantId?: UUID) => ['features', tenantId] as const,
  featureDetail: (tenantId?: UUID, providerId?: UUID, featureId?: UUID) =>
    ['feature', tenantId, providerId, featureId] as const,
  connectorFeaturesWithProviderOptionsByTenant: (tenantId?: UUID) =>
    ['connector-features-with-provider-options', tenantId] as const,
  availableProviderList: (tenantId?: UUID, limit?: number) =>
    ['importable-provider-manifests', tenantId, limit ?? null] as const,
  availableProviderListByTenant: (tenantId?: UUID) =>
    ['importable-provider-manifests', tenantId] as const,
};

export const providerMutationKeys = {
  createProvider: (tenantId?: UUID) => ['createProvider', tenantId] as const,
  updateProvider: (tenantId?: UUID, providerId?: UUID) =>
    ['updateProvider', tenantId, providerId] as const,
  deleteProvider: (tenantId?: UUID) => ['deleteProvider', tenantId] as const,
  enableProvider: (tenantId?: UUID) => ['enableProvider', tenantId] as const,
  disableProvider: (tenantId?: UUID) => ['disableProvider', tenantId] as const,
  importProviderFromManifest: (tenantId?: UUID) =>
    ['importProviderFromManifest', tenantId] as const,
  createProviderFeature: (
    tenantId?: UUID,
    providerId?: UUID,
    featureId?: UUID
  ) => ['createProviderFeature', tenantId, providerId, featureId] as const,
  deleteProviderFeature: (tenantId?: UUID, providerId?: UUID) =>
    ['deleteProviderFeature', tenantId, providerId] as const,
};
